/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Api
 * Postify AI API specification
 * OpenAPI spec version: 0.1.0
 */
export interface HealthStatus {
  status: string;
}

export interface VoiceAnalysis {
  tone: string;
  avgSentenceLength?: number;
  punctuationStyle?: string;
  emojiUsage?: string;
  humorLevel?: string;
  hookStyle?: string;
  vocabularyComplexity?: string;
  signaturePhrases?: string[];
  cadence?: string;
  cadenceScore?: number;
  formattingStyle?: string;
  hookTaxonomy?: string;
  hookExamples?: string[];
  ctaPattern?: string;
  storyPattern?: string;
  powerWords?: string[];
  writingPersonality?: string[];
  sentenceRhythm?: string;
  formattingPersonality?: string;
  sentenceFragments?: string[];
  punctuationFingerprint?: string;
  capitalizationQuirks?: string;
  fillerWordCadence?: string;
  selfInterruptions?: string[];
  typingFeel?: string;
  characteristicOpeners?: string[];
  characteristicClosers?: string[];
}

export type VoicePreferencesEmojiStyle =
  (typeof VoicePreferencesEmojiStyle)[keyof typeof VoicePreferencesEmojiStyle];

export const VoicePreferencesEmojiStyle = {
  love: "love",
  sparingly: "sparingly",
  never: "never",
} as const;

export type VoicePreferencesHashtagUsage =
  (typeof VoicePreferencesHashtagUsage)[keyof typeof VoicePreferencesHashtagUsage];

export const VoicePreferencesHashtagUsage = {
  always: "always",
  sometimes: "sometimes",
  never: "never",
} as const;

export type VoicePreferencesHumorLevel =
  (typeof VoicePreferencesHumorLevel)[keyof typeof VoicePreferencesHumorLevel];

export const VoicePreferencesHumorLevel = {
  serious: "serious",
  playful: "playful",
  jokester: "jokester",
} as const;

export type VoicePreferencesWritingStyle =
  (typeof VoicePreferencesWritingStyle)[keyof typeof VoicePreferencesWritingStyle];

export const VoicePreferencesWritingStyle = {
  professional: "professional",
  casual: "casual",
  raw: "raw",
} as const;

export type VoicePreferencesPostLength =
  (typeof VoicePreferencesPostLength)[keyof typeof VoicePreferencesPostLength];

export const VoicePreferencesPostLength = {
  short: "short",
  medium: "medium",
  long: "long",
} as const;

export type VoicePreferencesSentenceStyle =
  (typeof VoicePreferencesSentenceStyle)[keyof typeof VoicePreferencesSentenceStyle];

export const VoicePreferencesSentenceStyle = {
  staccato: "staccato",
  varied: "varied",
  flowing: "flowing",
} as const;

export type VoicePreferencesHookStyle =
  (typeof VoicePreferencesHookStyle)[keyof typeof VoicePreferencesHookStyle];

export const VoicePreferencesHookStyle = {
  "bold-claim": "bold-claim",
  "personal-story": "personal-story",
  question: "question",
  "stat-data": "stat-data",
  "hot-take": "hot-take",
} as const;

export type VoicePreferencesPersonalSharing =
  (typeof VoicePreferencesPersonalSharing)[keyof typeof VoicePreferencesPersonalSharing];

export const VoicePreferencesPersonalSharing = {
  "very-personal": "very-personal",
  balanced: "balanced",
  "keep-it-pro": "keep-it-pro",
} as const;

export type VoicePreferencesCtaStyle =
  (typeof VoicePreferencesCtaStyle)[keyof typeof VoicePreferencesCtaStyle];

export const VoicePreferencesCtaStyle = {
  "direct-ask": "direct-ask",
  "subtle-nudge": "subtle-nudge",
  "engage-question": "engage-question",
  "no-cta": "no-cta",
} as const;

export type VoicePreferencesLanguageEdge =
  (typeof VoicePreferencesLanguageEdge)[keyof typeof VoicePreferencesLanguageEdge];

export const VoicePreferencesLanguageEdge = {
  clean: "clean",
  "mild-edge": "mild-edge",
  unfiltered: "unfiltered",
} as const;

/**
 * User-defined stylistic preferences for post and reply generation
 */
export interface VoicePreferences {
  emojiStyle?: VoicePreferencesEmojiStyle;
  hashtagUsage?: VoicePreferencesHashtagUsage;
  humorLevel?: VoicePreferencesHumorLevel;
  writingStyle?: VoicePreferencesWritingStyle;
  postLength?: VoicePreferencesPostLength;
  sentenceStyle?: VoicePreferencesSentenceStyle;
  hookStyle?: VoicePreferencesHookStyle;
  personalSharing?: VoicePreferencesPersonalSharing;
  ctaStyle?: VoicePreferencesCtaStyle;
  languageEdge?: VoicePreferencesLanguageEdge;
  favoriteEmojis?: string;
  targetAudience?: string;
  additionalContext?: string;
}

export type VoiceStatsConfidenceLevel =
  (typeof VoiceStatsConfidenceLevel)[keyof typeof VoiceStatsConfidenceLevel];

export const VoiceStatsConfidenceLevel = {
  Low: "Low",
  Building: "Building",
  Strong: "Strong",
} as const;

export interface VoiceStats {
  textSampleCount: number;
  liveAudioCount: number;
  uploadedAudioCount: number;
  uploadedVideoCount: number;
  feedbackCount: number;
  totalSampleCount: number;
  sampleWordCounts: number[];
  confidenceLevel: VoiceStatsConfidenceLevel;
  firstTrainedAt?: string;
  lastTrainedAt?: string;
}

export interface CoachingNudge {
  id: string;
  message: string;
}

export interface VoiceProfile {
  id: string;
  sessionId: string;
  sampleCount: number;
  hasEnoughSamples: boolean;
  analysis?: VoiceAnalysis;
  preferences?: VoicePreferences;
  audioTranscripts?: string[];
  audioSampleCount?: number;
  stats?: VoiceStats;
  coachingNudges?: CoachingNudge[];
  createdAt: string;
  updatedAt: string;
}

export type UploadMediaResponseSource =
  (typeof UploadMediaResponseSource)[keyof typeof UploadMediaResponseSource];

export const UploadMediaResponseSource = {
  video: "video",
  audio: "audio",
} as const;

export interface UploadMediaResponse {
  success: boolean;
  transcript: string;
  wordCount: number;
  sampleCount: number;
  fileType: string;
  source: UploadMediaResponseSource;
  message: string;
}

export interface TrainVoiceRequest {
  /** @minItems 1 */
  samples: string[];
  sessionId?: string;
}

export interface TrainVoiceResponse {
  success: boolean;
  sampleCount: number;
  analysis?: VoiceAnalysis;
  message: string;
}

export interface TrainAudioRequest {
  audioBase64: string;
  sessionId?: string;
}

export interface TrainAudioResponse {
  success: boolean;
  transcript: string;
  sampleCount: number;
  analysis?: VoiceAnalysis;
  message: string;
}

export interface TranscribeRequest {
  audioBase64: string;
  sessionId?: string;
}

export interface TranscribeResponse {
  text: string;
  confidence?: number;
}

export interface ImportUrlRequest {
  url: string;
  sessionId?: string;
}

export interface ImportUrlResponse {
  success: boolean;
  text: string;
  platform: string;
  source: string;
  charCount: number;
}

/**
 * Override post length for this generation only
 */
export type GenerateAllPlatformsRequestPostLengthOverride =
  (typeof GenerateAllPlatformsRequestPostLengthOverride)[keyof typeof GenerateAllPlatformsRequestPostLengthOverride];

export const GenerateAllPlatformsRequestPostLengthOverride = {
  short: "short",
  medium: "medium",
  long: "long",
} as const;

/**
 * Structural style of the post
 */
export type GenerateAllPlatformsRequestPostStyle =
  (typeof GenerateAllPlatformsRequestPostStyle)[keyof typeof GenerateAllPlatformsRequestPostStyle];

export const GenerateAllPlatformsRequestPostStyle = {
  storytelling: "storytelling",
  factual: "factual",
  listicle: "listicle",
  "hot-take": "hot-take",
  question: "question",
  "how-to": "how-to",
  personal: "personal",
  industry: "industry",
} as const;

/**
 * Line/paragraph spacing preference
 */
export type GenerateAllPlatformsRequestSpacingStyle =
  (typeof GenerateAllPlatformsRequestSpacingStyle)[keyof typeof GenerateAllPlatformsRequestSpacingStyle];

export const GenerateAllPlatformsRequestSpacingStyle = {
  tight: "tight",
  spaced: "spaced",
  "single-line": "single-line",
  paragraph: "paragraph",
} as const;

/**
 * Opening hook style
 */
export type GenerateAllPlatformsRequestHookStyle =
  (typeof GenerateAllPlatformsRequestHookStyle)[keyof typeof GenerateAllPlatformsRequestHookStyle];

export const GenerateAllPlatformsRequestHookStyle = {
  "bold-statement": "bold-statement",
  question: "question",
  statistic: "statistic",
  anecdote: "anecdote",
} as const;

/**
 * Grammatical perspective
 */
export type GenerateAllPlatformsRequestPerspective =
  (typeof GenerateAllPlatformsRequestPerspective)[keyof typeof GenerateAllPlatformsRequestPerspective];

export const GenerateAllPlatformsRequestPerspective = {
  "first-person": "first-person",
  "second-person": "second-person",
  "third-person": "third-person",
} as const;

/**
 * How much humor to weave in
 */
export type GenerateAllPlatformsRequestHumorLevel =
  (typeof GenerateAllPlatformsRequestHumorLevel)[keyof typeof GenerateAllPlatformsRequestHumorLevel];

export const GenerateAllPlatformsRequestHumorLevel = {
  none: "none",
  "dry-wit": "dry-wit",
  witty: "witty",
  playful: "playful",
} as const;

/**
 * Target audience for the post
 */
export type GenerateAllPlatformsRequestAudience =
  (typeof GenerateAllPlatformsRequestAudience)[keyof typeof GenerateAllPlatformsRequestAudience];

export const GenerateAllPlatformsRequestAudience = {
  general: "general",
  professional: "professional",
  executive: "executive",
  friends: "friends",
} as const;

/**
 * Emoji density preference
 */
export type GenerateAllPlatformsRequestEmojiUsage =
  (typeof GenerateAllPlatformsRequestEmojiUsage)[keyof typeof GenerateAllPlatformsRequestEmojiUsage];

export const GenerateAllPlatformsRequestEmojiUsage = {
  off: "off",
  minimal: "minimal",
  natural: "natural",
  expressive: "expressive",
} as const;

export interface GenerateAllPlatformsRequest {
  idea: string;
  /**
   * @minimum 0
   * @maximum 100
   */
  tone?: number;
  sessionId?: string;
  /** Override post length for this generation only */
  postLengthOverride?: GenerateAllPlatformsRequestPostLengthOverride;
  /**
   * Optional per-post tone or style direction (e.g. "be sarcastic and blunt")
   * @maxLength 300
   */
  customInstruction?: string;
  /** Structural style of the post */
  postStyle?: GenerateAllPlatformsRequestPostStyle;
  /** Line/paragraph spacing preference */
  spacingStyle?: GenerateAllPlatformsRequestSpacingStyle;
  /** Opening hook style */
  hookStyle?: GenerateAllPlatformsRequestHookStyle;
  /** Grammatical perspective */
  perspective?: GenerateAllPlatformsRequestPerspective;
  /** How much humor to weave in */
  humorLevel?: GenerateAllPlatformsRequestHumorLevel;
  /** Target audience for the post */
  audience?: GenerateAllPlatformsRequestAudience;
  /** Emoji density preference */
  emojiUsage?: GenerateAllPlatformsRequestEmojiUsage;
  /**
   * Exact word count the AI must hit
   * @minimum 10
   * @maximum 3000
   */
  targetWordCount?: number;
}

export type GenerateAllPlatformsResponsePlatforms = { [key: string]: string };

export interface GenerateAllPlatformsResponse {
  platforms: GenerateAllPlatformsResponsePlatforms;
  /**
   * @minimum 0
   * @maximum 100
   */
  voiceMatchScore: number;
}

export type GeneratePostRequestPlatform =
  (typeof GeneratePostRequestPlatform)[keyof typeof GeneratePostRequestPlatform];

export const GeneratePostRequestPlatform = {
  twitter: "twitter",
  linkedin: "linkedin",
  reddit: "reddit",
  instagram: "instagram",
  facebook: "facebook",
} as const;

/**
 * Override post length for this generation only (ignores saved preference)
 */
export type GeneratePostRequestPostLengthOverride =
  (typeof GeneratePostRequestPostLengthOverride)[keyof typeof GeneratePostRequestPostLengthOverride];

export const GeneratePostRequestPostLengthOverride = {
  short: "short",
  medium: "medium",
  long: "long",
} as const;

/**
 * Structural style of the post
 */
export type GeneratePostRequestPostStyle =
  (typeof GeneratePostRequestPostStyle)[keyof typeof GeneratePostRequestPostStyle];

export const GeneratePostRequestPostStyle = {
  storytelling: "storytelling",
  factual: "factual",
  listicle: "listicle",
  "hot-take": "hot-take",
  question: "question",
  "how-to": "how-to",
  personal: "personal",
  industry: "industry",
} as const;

/**
 * Line/paragraph spacing preference
 */
export type GeneratePostRequestSpacingStyle =
  (typeof GeneratePostRequestSpacingStyle)[keyof typeof GeneratePostRequestSpacingStyle];

export const GeneratePostRequestSpacingStyle = {
  tight: "tight",
  spaced: "spaced",
  "single-line": "single-line",
  paragraph: "paragraph",
} as const;

/**
 * Opening hook style
 */
export type GeneratePostRequestHookStyle =
  (typeof GeneratePostRequestHookStyle)[keyof typeof GeneratePostRequestHookStyle];

export const GeneratePostRequestHookStyle = {
  "bold-statement": "bold-statement",
  question: "question",
  statistic: "statistic",
  anecdote: "anecdote",
} as const;

/**
 * Grammatical perspective
 */
export type GeneratePostRequestPerspective =
  (typeof GeneratePostRequestPerspective)[keyof typeof GeneratePostRequestPerspective];

export const GeneratePostRequestPerspective = {
  "first-person": "first-person",
  "second-person": "second-person",
  "third-person": "third-person",
} as const;

/**
 * How much humor to weave in
 */
export type GeneratePostRequestHumorLevel =
  (typeof GeneratePostRequestHumorLevel)[keyof typeof GeneratePostRequestHumorLevel];

export const GeneratePostRequestHumorLevel = {
  none: "none",
  "dry-wit": "dry-wit",
  witty: "witty",
  playful: "playful",
} as const;

/**
 * Target audience for the post
 */
export type GeneratePostRequestAudience =
  (typeof GeneratePostRequestAudience)[keyof typeof GeneratePostRequestAudience];

export const GeneratePostRequestAudience = {
  general: "general",
  professional: "professional",
  executive: "executive",
  friends: "friends",
} as const;

/**
 * Emoji density preference
 */
export type GeneratePostRequestEmojiUsage =
  (typeof GeneratePostRequestEmojiUsage)[keyof typeof GeneratePostRequestEmojiUsage];

export const GeneratePostRequestEmojiUsage = {
  off: "off",
  minimal: "minimal",
  natural: "natural",
  expressive: "expressive",
} as const;

export interface GeneratePostRequest {
  idea: string;
  platform: GeneratePostRequestPlatform;
  /**
   * Tone slider 0=casual 100=professional
   * @minimum 0
   * @maximum 100
   */
  tone?: number;
  sessionId?: string;
  /** Override post length for this generation only (ignores saved preference) */
  postLengthOverride?: GeneratePostRequestPostLengthOverride;
  /**
   * Optional per-post tone or style direction (e.g. "be sarcastic and blunt")
   * @maxLength 300
   */
  customInstruction?: string;
  /** Structural style of the post */
  postStyle?: GeneratePostRequestPostStyle;
  /** Line/paragraph spacing preference */
  spacingStyle?: GeneratePostRequestSpacingStyle;
  /** Opening hook style */
  hookStyle?: GeneratePostRequestHookStyle;
  /** Grammatical perspective */
  perspective?: GeneratePostRequestPerspective;
  /** How much humor to weave in */
  humorLevel?: GeneratePostRequestHumorLevel;
  /** Target audience for the post */
  audience?: GeneratePostRequestAudience;
  /** Emoji density preference */
  emojiUsage?: GeneratePostRequestEmojiUsage;
  /**
   * Exact word count the AI must hit
   * @minimum 10
   * @maximum 3000
   */
  targetWordCount?: number;
}

export interface Post {
  id: string;
  content: string;
  platform: string;
  voiceMatchScore: number;
  idea: string;
  sessionId?: string;
  createdAt: string;
}

export interface GeneratePostResponse {
  post: Post;
  /**
   * @minimum 0
   * @maximum 100
   */
  voiceMatchScore: number;
}

export interface PostsListResponse {
  posts: Post[];
  total: number;
}

export type RefinePostRequestAction =
  (typeof RefinePostRequestAction)[keyof typeof RefinePostRequestAction];

export const RefinePostRequestAction = {
  shorten: "shorten",
  expand: "expand",
  adjust_tone: "adjust_tone",
  polish: "polish",
  regenerate: "regenerate",
} as const;

export interface RefinePostRequest {
  action: RefinePostRequestAction;
  /**
   * @minimum 0
   * @maximum 100
   */
  toneValue?: number;
  sessionId?: string;
}

export interface Idea {
  id: string;
  title: string;
  notes: string;
  tags: string[];
  platform?: string;
  sessionId?: string;
  usedAt?: string | null;
  createdAt: string;
}

export interface CreateIdeaRequest {
  title: string;
  notes: string;
  tags?: string[];
  platform?: string;
  sessionId?: string;
  /** Origin of the idea (e.g. generator, studio, manual, reply) */
  source?: string;
}

export interface UpdateIdeaRequest {
  title?: string;
  notes?: string;
  tags?: string[];
  platform?: string;
  usedAt?: string | null;
}

export interface IdeasListResponse {
  ideas: Idea[];
  total: number;
}

export type GenerateHooksRequestPlatform =
  (typeof GenerateHooksRequestPlatform)[keyof typeof GenerateHooksRequestPlatform];

export const GenerateHooksRequestPlatform = {
  twitter: "twitter",
  linkedin: "linkedin",
  reddit: "reddit",
  instagram: "instagram",
  facebook: "facebook",
} as const;

export interface GenerateHooksRequest {
  topic: string;
  platform: GenerateHooksRequestPlatform;
  count?: number;
  sessionId?: string;
}

export interface GenerateHooksResponse {
  hooks: string[];
}

export interface GenerateThreadRequest {
  topic: string;
  /**
   * @minimum 3
   * @maximum 10
   */
  tweetCount?: number;
  sessionId?: string;
}

export interface GenerateThreadResponse {
  tweets: string[];
  hookTweet: string;
  ctaTweet: string;
}

export type RepurposeRequestSourcePlatform =
  (typeof RepurposeRequestSourcePlatform)[keyof typeof RepurposeRequestSourcePlatform];

export const RepurposeRequestSourcePlatform = {
  twitter: "twitter",
  linkedin: "linkedin",
  reddit: "reddit",
  instagram: "instagram",
  facebook: "facebook",
} as const;

export type RepurposeRequestTargetPlatformsItem =
  (typeof RepurposeRequestTargetPlatformsItem)[keyof typeof RepurposeRequestTargetPlatformsItem];

export const RepurposeRequestTargetPlatformsItem = {
  twitter: "twitter",
  linkedin: "linkedin",
  reddit: "reddit",
  instagram: "instagram",
  facebook: "facebook",
} as const;

export interface RepurposeRequest {
  originalPost: string;
  sourcePlatform: RepurposeRequestSourcePlatform;
  targetPlatforms: RepurposeRequestTargetPlatformsItem[];
  sessionId?: string;
}

export type RepurposeResponseRepurposed = { [key: string]: string };

export interface RepurposeResponse {
  repurposed: RepurposeResponseRepurposed;
}

export type GenerateHashtagsRequestPlatform =
  (typeof GenerateHashtagsRequestPlatform)[keyof typeof GenerateHashtagsRequestPlatform];

export const GenerateHashtagsRequestPlatform = {
  twitter: "twitter",
  linkedin: "linkedin",
  reddit: "reddit",
  instagram: "instagram",
  facebook: "facebook",
} as const;

export interface GenerateHashtagsRequest {
  content: string;
  platform: GenerateHashtagsRequestPlatform;
  count?: number;
}

export interface GenerateHashtagsResponse {
  hashtags: string[];
}

export type GenerateCTARequestGoal =
  (typeof GenerateCTARequestGoal)[keyof typeof GenerateCTARequestGoal];

export const GenerateCTARequestGoal = {
  follow: "follow",
  engage: "engage",
  click: "click",
  share: "share",
  comment: "comment",
  buy: "buy",
} as const;

export interface GenerateCTARequest {
  postContent: string;
  goal: GenerateCTARequestGoal;
  count?: number;
  sessionId?: string;
}

export interface GenerateCTAResponse {
  ctas: string[];
}

export type ExpandIdeaRequestPlatform =
  (typeof ExpandIdeaRequestPlatform)[keyof typeof ExpandIdeaRequestPlatform];

export const ExpandIdeaRequestPlatform = {
  twitter: "twitter",
  linkedin: "linkedin",
  reddit: "reddit",
  instagram: "instagram",
  facebook: "facebook",
} as const;

export interface ExpandIdeaRequest {
  idea: string;
  platform: ExpandIdeaRequestPlatform;
  sessionId?: string;
}

export interface ExpandIdeaResponse {
  angles: string[];
  relatedTopics: string[];
  suggestedHooks: string[];
}

export interface Brainstorm {
  id: string;
  sessionId: string;
  content: string;
  createdAt: string;
}

export interface CreateBrainstormRequest {
  /**
   * @minLength 3
   * @maxLength 2000
   */
  content: string;
}

export interface BrainstormsListResponse {
  brainstorms: Brainstorm[];
}

export type GenerateSmartReplyRequestTone =
  (typeof GenerateSmartReplyRequestTone)[keyof typeof GenerateSmartReplyRequestTone];

export const GenerateSmartReplyRequestTone = {
  professional: "professional",
  friendly: "friendly",
  casual: "casual",
  assertive: "assertive",
  empathetic: "empathetic",
  concise: "concise",
} as const;

export type GenerateSmartReplyRequestFormat =
  (typeof GenerateSmartReplyRequestFormat)[keyof typeof GenerateSmartReplyRequestFormat];

export const GenerateSmartReplyRequestFormat = {
  email: "email",
  chat: "chat",
  formal_letter: "formal_letter",
} as const;

/**
 * Override reply length for this generation only
 */
export type GenerateSmartReplyRequestReplyLength =
  (typeof GenerateSmartReplyRequestReplyLength)[keyof typeof GenerateSmartReplyRequestReplyLength];

export const GenerateSmartReplyRequestReplyLength = {
  short: "short",
  medium: "medium",
  long: "long",
} as const;

/**
 * How much humor to weave in
 */
export type GenerateSmartReplyRequestHumorLevel =
  (typeof GenerateSmartReplyRequestHumorLevel)[keyof typeof GenerateSmartReplyRequestHumorLevel];

export const GenerateSmartReplyRequestHumorLevel = {
  none: "none",
  "dry-wit": "dry-wit",
  witty: "witty",
  playful: "playful",
} as const;

/**
 * Target audience for the reply
 */
export type GenerateSmartReplyRequestAudience =
  (typeof GenerateSmartReplyRequestAudience)[keyof typeof GenerateSmartReplyRequestAudience];

export const GenerateSmartReplyRequestAudience = {
  general: "general",
  professional: "professional",
  executive: "executive",
  friends: "friends",
} as const;

/**
 * Emoji density preference
 */
export type GenerateSmartReplyRequestEmojiUsage =
  (typeof GenerateSmartReplyRequestEmojiUsage)[keyof typeof GenerateSmartReplyRequestEmojiUsage];

export const GenerateSmartReplyRequestEmojiUsage = {
  off: "off",
  minimal: "minimal",
  natural: "natural",
  expressive: "expressive",
} as const;

/**
 * Urgency of the message
 */
export type GenerateSmartReplyRequestUrgency =
  (typeof GenerateSmartReplyRequestUrgency)[keyof typeof GenerateSmartReplyRequestUrgency];

export const GenerateSmartReplyRequestUrgency = {
  relaxed: "relaxed",
  normal: "normal",
  urgent: "urgent",
} as const;

/**
 * Additional formality dial (layered on top of tone)
 */
export type GenerateSmartReplyRequestFormality =
  (typeof GenerateSmartReplyRequestFormality)[keyof typeof GenerateSmartReplyRequestFormality];

export const GenerateSmartReplyRequestFormality = {
  casual: "casual",
  professional: "professional",
  formal: "formal",
} as const;

/**
 * Relationship archetype that shapes AI communication style
 */
export type GenerateSmartReplyRequestPersonaArchetype =
  (typeof GenerateSmartReplyRequestPersonaArchetype)[keyof typeof GenerateSmartReplyRequestPersonaArchetype];

export const GenerateSmartReplyRequestPersonaArchetype = {
  boss: "boss",
  parent: "parent",
  partner: "partner",
  best_friend: "best_friend",
  client: "client",
  recruiter: "recruiter",
  doctor: "doctor",
  colleague: "colleague",
  mentor: "mentor",
} as const;

/**
 * Power dynamic between writer and recipient
 */
export type GenerateSmartReplyRequestPersonaPowerDynamic =
  (typeof GenerateSmartReplyRequestPersonaPowerDynamic)[keyof typeof GenerateSmartReplyRequestPersonaPowerDynamic];

export const GenerateSmartReplyRequestPersonaPowerDynamic = {
  equal: "equal",
  they_have_authority: "they_have_authority",
  you_have_authority: "you_have_authority",
} as const;

/**
 * Preferred communication style of the recipient
 */
export type GenerateSmartReplyRequestPersonaCommunicationStyle =
  (typeof GenerateSmartReplyRequestPersonaCommunicationStyle)[keyof typeof GenerateSmartReplyRequestPersonaCommunicationStyle];

export const GenerateSmartReplyRequestPersonaCommunicationStyle = {
  direct_blunt: "direct_blunt",
  diplomatic_warm: "diplomatic_warm",
  formal_structured: "formal_structured",
} as const;

/**
 * How well the writer knows the recipient
 */
export type GenerateSmartReplyRequestPersonaFamiliarityLevel =
  (typeof GenerateSmartReplyRequestPersonaFamiliarityLevel)[keyof typeof GenerateSmartReplyRequestPersonaFamiliarityLevel];

export const GenerateSmartReplyRequestPersonaFamiliarityLevel = {
  stranger: "stranger",
  acquaintance: "acquaintance",
  close: "close",
} as const;

export interface GenerateSmartReplyRequest {
  /** @maxLength 2000 */
  originalMessage?: string;
  /**
   * @minLength 1
   * @maxLength 2000
   */
  intentNote: string;
  tone: GenerateSmartReplyRequestTone;
  format: GenerateSmartReplyRequestFormat;
  /** Override reply length for this generation only */
  replyLength?: GenerateSmartReplyRequestReplyLength;
  /** When true, treats originalMessage as a rough draft to voice-align rather than a message to reply to */
  polishMode?: boolean;
  /** How much humor to weave in */
  humorLevel?: GenerateSmartReplyRequestHumorLevel;
  /** Target audience for the reply */
  audience?: GenerateSmartReplyRequestAudience;
  /** Emoji density preference */
  emojiUsage?: GenerateSmartReplyRequestEmojiUsage;
  /** Urgency of the message */
  urgency?: GenerateSmartReplyRequestUrgency;
  /** Additional formality dial (layered on top of tone) */
  formality?: GenerateSmartReplyRequestFormality;
  /**
   * Optional custom direction (e.g. "keep it under 3 sentences and end with a question")
   * @maxLength 300
   */
  customInstruction?: string;
  /**
   * Exact word count the AI must hit
   * @minimum 5
   * @maximum 2000
   */
  targetWordCount?: number;
  /**
   * Name of the person being written to (from relationship preset)
   * @maxLength 60
   */
  personaName?: string;
  /** Relationship archetype that shapes AI communication style */
  personaArchetype?: GenerateSmartReplyRequestPersonaArchetype;
  /** Power dynamic between writer and recipient */
  personaPowerDynamic?: GenerateSmartReplyRequestPersonaPowerDynamic;
  /** Preferred communication style of the recipient */
  personaCommunicationStyle?: GenerateSmartReplyRequestPersonaCommunicationStyle;
  /** How well the writer knows the recipient */
  personaFamiliarityLevel?: GenerateSmartReplyRequestPersonaFamiliarityLevel;
  /**
   * Topics or approaches to avoid when writing to this person
   * @maxLength 300
   */
  personaAvoidTopics?: string;
}

export interface SmartReply {
  id: string;
  sessionId: string;
  originalMessage: string;
  intentNote: string;
  tone: string;
  format: string;
  generatedReply: string;
  createdAt: string;
}

export interface GenerateSmartReplyResponse {
  reply: SmartReply;
}

export interface ReplyHistoryResponse {
  replies: SmartReply[];
  total: number;
}

/**
 * Thumbs up adds content to voice training pool; thumbs down logs the negative signal
 */
export type VoiceFeedbackRequestRating =
  (typeof VoiceFeedbackRequestRating)[keyof typeof VoiceFeedbackRequestRating];

export const VoiceFeedbackRequestRating = {
  up: "up",
  down: "down",
} as const;

export interface VoiceFeedbackRequest {
  /** The generated post or reply content (used directly if no postId/replyId provided) */
  content?: string;
  /** Optional post ID — server will look up content from the posts table (session-scoped) */
  postId?: string;
  /** Optional reply ID — server will look up content from the replies table (session-scoped) */
  replyId?: string;
  /** Thumbs up adds content to voice training pool; thumbs down logs the negative signal */
  rating: VoiceFeedbackRequestRating;
}

export interface VoiceFeedbackResponse {
  success: boolean;
  message: string;
  /** Whether the content was added to voice training (only true on thumbs up with sufficient word count) */
  addedToTraining: boolean;
  /** Whether the content was stored as a negative example to avoid (only true on thumbs down) */
  addedToNegativeExamples?: boolean;
}

export type ResetVoiceProfile200 = {
  success: boolean;
  message: string;
};

export type DeleteAudioTranscriptBody = {
  index: number;
};

export type UploadVoiceMediaBody = {
  file: Blob;
};

export type GetPostsParams = {
  limit?: number;
  offset?: number;
};

export type GetIdeasParams = {
  limit?: number;
  offset?: number;
};

export type GetReplyHistoryParams = {
  limit?: number;
  offset?: number;
};
